import { Navigate } from "react-router-dom";
import PreLogin from "../components/PreLogin/PreLogin";
import SignIn from "../components/Auth/SignIn/SignIn";
import AdminLayout from "../layouts/AdminLayout/AdminLayout";
import Dashboard from "components/admin/Dashboard/Dashboard";
import UserMangement from "components/admin/UserManagement/UserMangement";
import PostMonitoring from "components/admin/PostMonitoring/PostMonitoring";
import ProjectMonitoring from "components/admin/ProjectMonitoring/ProjectMonitoring";
import Subscription from "components/admin/Subscription/Subscription";
import Payments from "components/admin/Payments/Payments";
import { lazy } from "react";
import Setting from "components/admin/Setting/Setting";
const LazyContactUs=lazy(()=>import("../pages/ContactUs/ContactUs"))


const adminRoutes = [
  {
    path: "/",
    isPrivate: false,
    isRestricted: true,
    element: <PreLogin />,
    children: [
      {
        path: "/signin",
        element: <SignIn />,
      },
      {
        path: "/contact-us",
        element: <LazyContactUs />,
      },
    ],
  },
  {
    path: "/",
    isPrivate: true,
    element: <AdminLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" />,
        isPrivate: false,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
        isPrivate: false,
      },
       {
        path: "/contact-us",
        element: <LazyContactUs />,
        isPrivate:false,
      },
      {
        path: "project-monitoring",
        element: <ProjectMonitoring />,
        isPrivate: false,
      },
      {
        path: "post-monitoring",
        element: <PostMonitoring />,
        isPrivate: false,
      },
      {
        path: "user-management",
        element: <UserMangement />,
        isPrivate: false,
      },
      {
        path: "subscription",
        element: <Subscription />,
        isPrivate: false,
      },
      {
        path: "payments",
        element: <Payments />,
        isPrivate: false,
      },
      {
        path: "setting",
        element: <Setting />,
        isPrivate: false,
      },
    ],
  },
];

export default adminRoutes;
